import script from "./TermsAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAccept.vue?vue&type=script&setup=true&lang=js"

import "./TermsAccept.vue?vue&type=style&index=0&id=add1a75c&lang=css"

const __exports__ = script;

export default __exports__